import http from "../../http";
import accounts from "./account";
let bindlist = data => {
  return http.post("opservice/wechatmanage/page", data);
};
let bindsave = data => {
  return http.post("opservice/wechatmanage/save", data);
};
let binddel = data => {
  return http.post("opservice/wechatmanage/delete", data);
};
let list = () => {
  return http.get("opservice/userFormField/get/userFormBaseField");
};
let formList = () => {
  return http.get("opservice/userFormField/get/form");
};
let save = param => {
  return http.post("opservice/userFormField/save/formfield", param);
};
let remove = param => {
  return http.get("opservice/userFormField/remove?id=" + param);
};
let update = param => {
  return http.post("opservice/userFormField/update/formfield", param);
};
let setdata = params => {
  return http.post("opservice/tenantconf/save", params);
};
export default {
  bindlist,
  bindsave,
  binddel,
  list,
  formList,
  save,
  remove,
  update,
  setdata,
  accounts,
  // 小程序相关接口
  miniprogram: {
    // 生成小程序码
    createQRCode: params => {
      return http.post("opservice/wx/app/wxACode", params);
    },
    // 更新小程序码
    updateQRCode: params => {
      return http.post("opservice/wx/app/wxACode/update", params);
    }
  },
  // 公众号相关接口
  account: {
    scanList: params => {
      return http.get("marketcenter/webchatcollocation/appList/page", params);
    },
    message: {
      list: params => {
        return http.get("marketcenter/wxproxy/sendmsg_page", params);
      }
    }
  },
  media: {
    uploadByBase64: (params, appid) => {
      return http.post(
        "/wxmp/wx/" + appid + "/media/uploadimg/base64",
        params
      );
    }
  },
  yxSetting: {
    get: (params, appid) => {
      return http.get("/wxmp/wx/" + appid + "/custom/setting/get", params);
    },
    save: (params, appid) => {
      return http.post("/wxmp/wx/" + appid + "/custom/setting", params);
    }
  }
};
